// extracted by mini-css-extract-plugin
module.exports = {"root":"SavingPopup_root__wHzUn","icon":"SavingPopup_icon__JjOdP","subheading":"SavingPopup_subheading__zctks"};